"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _lodash = _interopRequireDefault(require("lodash"));

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _shareButton = _interopRequireDefault(require("./share-button"));

require("./share-group.less");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

/**
 * Render a list of `ShareButton`s, one for each of the given `sites`. All the
 * rest of the props are passed through to each `ShareButton`, which will
 * handle rendering a share button as required. This is a convenience
 * component to provide consistent styling for a group of `ShareButton`s that
 * share the same content to different social sites.
 *
 * @type {{[p: string]: *}} sites - ordered (left-to-right) list of sites to render buttons for
 * @param url - passed on to ShareButton - the url of the content being shared
 * @param hashtag - passed on to ShareButton - do not include the # character e.g. 'glowforge'
 * @param text - passed on to ShareButton - the primary short-text to pre-populate share content
 * @param quote - passed on to ShareButton - a quote from Glowforge to include alongside the url
 * @param image - passed on to ShareButton - an image to share (only supported by pinterest)
 * @param props.size - passed on to SocialIcon - standard sizes small, medium, or large
 * @param props.appearance - passed on to SocialIcon - available styles square, round, clear
 */
var ShareGroup = function ShareGroup(_ref) {
  var sites = _ref.sites,
      childProps = _objectWithoutProperties(_ref, ["sites"]);

  var buttons = _lodash["default"].map(sites, function (site) {
    return /*#__PURE__*/_react["default"].createElement("li", {
      className: "siteItem",
      key: site
    }, /*#__PURE__*/_react["default"].createElement(_shareButton["default"], _extends({
      site: site
    }, childProps)));
  });

  return /*#__PURE__*/_react["default"].createElement("div", {
    className: "ShareGroup"
  }, /*#__PURE__*/_react["default"].createElement("ul", {
    className: "siteList"
  }, buttons));
};

ShareGroup.propTypes = _objectSpread(_objectSpread({}, _lodash["default"].omit(_shareButton["default"].propTypes, ['site'])), {}, {
  sites: _propTypes["default"].arrayOf(_shareButton["default"].propTypes.site).isRequired
});
var _default = ShareGroup;
exports["default"] = _default;